var Sharer;
(function (Sharer) {
    myonce('sharer', () => {
        const $targets = document.querySelectorAll('[data-share]');
        $targets.forEach(($sharer) => {
            let timeout;
            const $sharerList = $sharer.nextElementSibling;
            $sharer.addEventListener('click', () => {
                clearTimeout(timeout);
                let popper = new Popper($sharer, $sharerList, {
                    placement: (() => {
                        return window.innerWidth < 992 ? 'bottom-center' : 'right-center';
                    })(),
                });
                if ($sharerList.classList.contains('is-active')) {
                    popper.destroy();
                }
                else {
                    timeout = setTimeout(() => {
                        $sharerList.classList.remove('is-active');
                        popper.destroy();
                    }, 6000);
                }
                $sharerList.classList.toggle('is-active');
            });
            window.addEventListener('click', function (e) {
                const target = e.target;
                if (!$sharer.contains(target)) {
                    let popper = new Popper($sharer, $sharerList, {
                        placement: (() => {
                            return window.innerWidth < 992 ? 'bottom-center' : 'right-center';
                        })(),
                    });
                    if ($sharerList.classList.contains('is-active')) {
                        popper.destroy();
                        $sharerList.classList.toggle('is-active');
                    }
                }
            });
        });
    });
})(Sharer || (Sharer = {}));
